import React from "react";
import { Form, Segment } from "semantic-ui-react";
import Swal from "sweetalert2";
import { estiloColores } from "../../estilos/colores";
import { apiViaje } from "../../api/viaje";
import "../../scss/index.scss";

const apiviaje = new apiViaje();

export function ViajePagar({
  Id,
  Estado,
  Destino,
  Precio,
  Moneda,
  UsuarioId,
  setEstado,
  ChoferId,
}) {
  const ConfirmarPago = async () => {
    Swal.fire({
      title: "Realizar pago del viaje?",
      text: "",
      // type: "warning",
      showCancelButton: true,
      confirmButtonText: "Si",
      confirmButtonColor: estiloColores.Azul,
      cancelButtonText: "Cancelar",
      cancelButtonColor: estiloColores.Gris,
    }).then((result) => {
      if (result.value) {
        ViajePagarAccion();
      }
    });
  };

  const ViajePagarAccion = async () => {
    await apiviaje.confirmarPago(Id, ChoferId);

    Swal.fire({
      // type: "success",
      title: "Pago realizado exitosamente",
      text: "",
      timer: 1500,
      showCancelButton: false,
      showConfirmButton: false,
    });

    setEstado("ESPERANDO VEHÍCULO");
  };

  return (
    <div>
      <Segment secondary className="segmentViajePagar">
        Pagar viaje con destino a: <b>{Destino}</b>
        <br></br>
        Importe:{" "}
        <b>
          {Moneda}
          {Precio}
        </b>
        .<br></br>
        <Segment>
          <Form.Field>
            <input
              placeholder="Número de tarjeta (débito/crédito)"
              maxLength={16}
            />
          </Form.Field>
          <Form.Field>
            <input placeholder="Nombre (como aparece en la tarjeta)" />
          </Form.Field>
          <Form.Field>
            <input placeholder="Vencimiento (MM/AA)" maxLength={5} />
          </Form.Field>
          <Form.Field>
            <input placeholder="Código de seguridad (XXX)" maxLength={3} />
          </Form.Field>
          <button className="ui fluid button" onClick={(e) => ConfirmarPago(e)}>
            Realizar pago
          </button>
        </Segment>
      </Segment>
    </div>
  );
}
